import { z } from 'zod';
// Shared between backend (controller DTO + use case input) and frontend
// (admin form + API client). Events module (§6.7) — S2 guest list (task 2.9).
// billingMode mirrors ADR-E4 exactly; nullable per spec R7.6 (a
// `combination`-mode guest may be created with no billingMode yet).
export const EventGuestBillingModeSchema = z.enum(['host', 'self', 'free']);
// ── Guest create (single + bulk pre-load, R2.1) ─────────────────────────────
export const CreateEventGuestRequestSchema = z.object({
    name: z.string().trim().min(1, 'Name is required').max(200),
    plate: z.string().trim().min(1).max(20).nullable().optional(),
    billingMode: EventGuestBillingModeSchema.nullable().optional(),
});
export const BulkAddEventGuestsRequestSchema = z.object({
    guests: z.array(CreateEventGuestRequestSchema).min(1, 'At least one guest is required').max(500),
});
// ── Response shapes ──────────────────────────────────────────────────────────
export const EventGuestResponseSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    eventId: z.string().uuid(),
    name: z.string(),
    plate: z.string().nullable(),
    billingMode: EventGuestBillingModeSchema.nullable(),
    ticketId: z.string().uuid().nullable(),
    arrivedAt: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const ListEventGuestsResponseSchema = z.object({
    guests: z.array(EventGuestResponseSchema),
});
export const BulkAddEventGuestsResponseSchema = z.object({
    guests: z.array(EventGuestResponseSchema),
});
// ── Matching (R2.3/R2.4 — consumed by S4 Flash check-in) ────────────────────
// S5 (task: wire GET /events/:id/guests/match) — query params for the
// plate-first/name-fallback lookup (MatchGuestByPlateOrNameUseCase). Both
// optional (the use case itself tolerates neither being set, returning an
// unmatched/walk-in result), mirroring the use case's own flexibility.
export const MatchEventGuestQuerySchema = z.object({
    plate: z.string().trim().min(1).max(20).optional(),
    name: z.string().trim().min(1).max(200).optional(),
});
export const MatchEventGuestsResponseSchema = z.object({
    matched: z.boolean(),
    ambiguous: z.boolean(),
    candidates: z.array(EventGuestResponseSchema),
});
//# sourceMappingURL=event-guest-schemas.js.map